module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/hero-bd80739268cbc10c653fb0db357190c4.jpg";